import Card from '@components/Card';
import { getColumn, hydrateColumns } from '@utils/columns';
import { getRatingCSSColor } from '@utils/rating';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { LoginStatePart, PermissionsStatePart, SettingStatePart } from '../../setup/types';
import { Attribute, HydratedEntity } from '../../types';
import { enablePerform3 } from '../settings/reducer';

const totalRating = getColumn('totalRating');
const totalRatingV2 = getColumn('totalRatingV2');
const totalRatingV3 = getColumn('totalRatingV3');
const electricForesightedDrivingPercentage = getColumn('electricForesightedDrivingPercentage');

export const Total = ({
    entity,
    shouldUseV2Ratings,
    shouldUseV3Ratings,
    isElectricVehicle = false,
    attributes = [],
}: {
    entity: HydratedEntity;
    shouldUseV2Ratings: boolean;
    shouldUseV3Ratings: boolean;
    isElectricVehicle: boolean;
    attributes?: Attribute[];
} & { dispatch?: Dispatch }): JSX.Element => {
    const rawColumn = isElectricVehicle
        ? electricForesightedDrivingPercentage
        : shouldUseV3Ratings
        ? totalRatingV3
        : shouldUseV2Ratings
        ? totalRatingV2
        : totalRating;

    const column = rawColumn ? hydrateColumns([rawColumn], attributes || [], { plain: true })[0] : undefined;
    const value = column?.valueExtractor(entity) as number;
    const { color } = getRatingCSSColor(value);
    const labelId = isElectricVehicle ? 'rating.electric' : 'rating.fuel';

    return (
        <Card
            title={<FormattedMessage id={labelId} />}
            score={
                <span className={cn('text-size-12 text-bold', color)}>
                    <span className="text-size-200pct"> {column?.formatter(value)} </span>
                </span>
            }
        />
    );
};

export const mapStateToProps = (state: SettingStatePart & PermissionsStatePart & LoginStatePart) => ({
    shouldUseV2Ratings: enablePerform3(state),
});

export default connect(mapStateToProps)(Total);
